"use client";

import {
  Box,
  Button,
  Icon,
  ModalContent,
  ModalFooter,
  PortalModal,
  Text,
  usePortalContext,
} from "@cloai/uikit";
import { useTranslations } from "next-intl";
import { FC, useEffect } from "react";
import { useCookies } from "react-cookie";

import { useGTMContext, useProfileContext } from "@/providers";
import ImgOriginal from "@/styles/image/faq-anime-1.jpg";
import ImgHD from "@/styles/image/faq-anime-2.jpg";

import { ModalCompareImg } from "../tutor/ModalCompareImg";
import { COOKIES, COOKIES_TIMES } from ".constants/cookies";
import { GE } from ".constants/gtmEvents";
import { PATH_BUY } from ".constants/links";
import { PORTALS } from ".constants/portals";
import undressConfig from ".constants/undress.config.json";

export const TutorAnimePortal: FC = () => {
  const t = useTranslations("AnimeModal");
  const { currentPortal, closePortal } = usePortalContext();
  const profile = useProfileContext();
  const { sendGTM } = useGTMContext();
  const [, setCookies] = useCookies([COOKIES.TUTOR_ART_IS_READED]);

  useEffect(() => {
    if (currentPortal === PORTALS.TUTOR_ANIME) {
      setCookies(COOKIES.TUTOR_ART_IS_READED, 1, {
        maxAge: COOKIES_TIMES.YEAR_1, // примерно год в секундах
      });
    }
  }, [currentPortal, setCookies]);

  const noCoins = !(profile?.coins! >= undressConfig.undressCost);

  const handleBuyCoins = () => {
    sendGTM({ event: GE.TUTOR_3D_BUY_COIN });
    closePortal();
  };

  return (
    <PortalModal portalId={PORTALS.TUTOR_ANIME}>
      <ModalContent>
        <Box gap={4} row>
          <ModalCompareImg
            img={ImgOriginal}
            meta={t("imgMeta.alt")}
            text="Original"
          />

          <ModalCompareImg
            img={ImgHD}
            meta={t("imgMeta.alt")}
            text={
              <Box gap={4} row center>
                3D Art
                <div className="material-icons" data-icon="diamond"></div>
              </Box>
            }
          />
        </Box>

        <Text
          text={t.rich("text", {
            span: (chunks) => <span data-color="orange">{chunks}</span>,
          })}
          center
        />
      </ModalContent>

      <ModalFooter>
        <Box gap={12} center row>
          <Button
            endContent={<Icon icon="close" />}
            size="xl"
            variant="ghost"
            wide
            centerText={!noCoins}
            onClick={closePortal}
          >
            {t("close")}
          </Button>

          {noCoins && (
            <Button
              href={PATH_BUY}
              scroll={false}
              startContent={<Icon icon="verified" />}
              size="xl"
              color="primary"
              wide
              onClick={handleBuyCoins}
            >
              {t("buy")}
            </Button>
          )}
        </Box>
      </ModalFooter>
    </PortalModal>
  );
};
